// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__23tFv","current":"style_current__hlzNs","arrow":"style_arrow__a7x7-"};